import mobileAdjustment from "../GeneralMobileAdjustments";

class MobilePlayReportButtonControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setButtonsHeight(element);
    }
}

const mobilePlayReportButtonControlView = new MobilePlayReportButtonControlView();
export default mobilePlayReportButtonControlView;